import { render, staticRenderFns } from "./HeroClassLevel.vue?vue&type=template&id=5da41778&"
import script from "./HeroClassLevel.vue?vue&type=script&lang=js&"
export * from "./HeroClassLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports